export default __webpack_public_path__ + "static/media/rafa10.bc633aa1.jpg";